import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import { Formik, Form, Field } from "formik";

import { toast } from "react-toastify";
import {
  getAllAgentsService,
  reassignLoanService,
} from "../../services/agentService";

const ReassignLoanModal = ({ open, onClose, loanId, type }) => {
  const [agents, setAgents] = useState([]);
  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts); // Adjust this based on API response structure
    } catch (err) {
      toast.error(err.message);
    }
  };
  useEffect(() => {
    fetchAgents();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      console.log(loanId, values.agent);

      await reassignLoanService(loanId, values.agent, type); // API call to update loan agent

      toast.success("Loan reassigned successfully"); // Success toast
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to reassign loan"); // Error toast
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" mb={2}>
          Reassign Loan
        </Typography>
        <Formik initialValues={{ agent: "" }} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>Agent</Typography>
                  <Field
                    as={TextField}
                    name="agent"
                    select
                    fullWidth
                    size="small"
                    required
                  >
                    {agents.map((agent) => (
                      <MenuItem key={agent._id} value={agent._id}>
                        {agent.userName}
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button onClick={onClose} sx={{ mr: 1 }} variant="outlined">
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default ReassignLoanModal;
